import React from 'react';
export const ToolbarContext = React.createContext({});
//# sourceMappingURL=context.js.map